import { createContext, type PropsWithChildren, useContext, useEffect, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AddMembersStore } from 'pages/settings/pages/members/pages/addMembers/store/addMembersStore'

export const AddMembersContext = createContext<AddMembersStore | null>(null)

export const useAddMembersContext = () => {
  const context = useContext(AddMembersContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AddMembersContext')

  return context
}

export const AddMembersProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new AddMembersStore(entities), [entities])

  useEffect(() => {
    store.init()

    return () => {
      store.reset()
    }
  }, [store])

  return <AddMembersContext.Provider value={store}>{children}</AddMembersContext.Provider>
}
